import React from 'react';
import './style.scss'
import { Link } from 'react-router-dom'

import Menu from '../../components/Menu'
// import Body from '../../components/Body'
import Footer from '../../components/Footer'

import ImgBannerWebshoppers42 from '../../assets/imagens/01_Bexs_logo_tagline_secundario_transp_RGB.png'
import ImgWsPr43 from '../../assets/imagens/webshoppers/ws-premium-43.PNG'
import ImgBannerFooter from '../../assets/imagens/img-shopper01.ad471829.jpg'

import ImgWebshoppersFree from '../../assets/imagens/webshoppers/Capa-WB43Free.PNG'
import ImgWebshoppersPremium from '../../assets/imagens/webshoppers/Capa-WB43Premium.PNG'
import ImgWebshoppersCustom from '../../assets/imagens/webshoppers/Capa-WB43Capitulos.PNG'

import Accordion from 'react-bootstrap/Accordion'
import Button from 'react-bootstrap/Button'

function WebshoppersPremium() {


  return (
    <>
      <Menu />

      <div className="banner-webshoppers-premium">
        <div className="banner-webshoppers-premium__text-bn-ws-pr-43 container">

          <div className="descripition-ws-premium-43">
            <h1>43ª ed.</h1>
            <h1>Webshoppers</h1>
          </div>

          <div className="vs-title">
            <p>Premium</p>
          </div>

          <div className="">
            <img src={ImgBannerWebshoppers42} alt="Logo bexs" />
          </div>

        </div>
      </div>


      <div className="content-ws-pr-43 container">
        {/* <h2>Versão Premium</h2> */}
        <div className="report-info">
          <img src={ImgWsPr43} alt="" />
          <p className="lead">
            Nesta versão completa do relatório, abordamos em detalhes 4 grandes
          capítulos, <b>Overview do E-commerce</b> (Tipos de operação,
          Marketplace, Categorias de produto, M- commerce, Perfil dos
          consumidores e regionalidades com seus deep dives), <b>Novos
          consumidores, Datas sazonais e Cross Border Trade.</b>
          </p>
        </div>

        <Accordion className="acc-test">

          {/* <h3>Overview do E-commerce</h3> */}

          <Accordion.Toggle as={Button} variant="link" eventKey="0" className="btn-toggle">
            <h3>Overview do e-commerce</h3>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <div className="report-itens">

              <div className="descripition-itens">
                <h4>Overview do e-commerce</h4>
                <p className="lead">Evolução do faturamento, pedidos e ticket médio ao longo dos últimos anos das vendas online e seus segmentos de loja. Consumidores do e-commerce, entre novos e recorrentes</p>
              </div>

              <div className="descripition-itens">
                <h4>Categorias de produto</h4>
                <p className="lead">Desempenho das categorias de bens duráveis, não duráveis e semiduráveis em faturamento e pedidos</p>
              </div>

              <div className="descripition-itens">
                <h4>M-commerce</h4>
                <p className="lead">Evolução do mobile ao longo dos últimos anos e sua importância para o segmento de loja</p>
              </div>

              <div className="descripition-itens">
                <h4>Perfil dos consumidores</h4>
                <p className="lead">Perfil dos consumidores online e diferenças entre os segmentos de loja</p>
              </div>

              <div className="descripition-itens">
                <h4>Regionalidades</h4>
                <p className="lead">Como foi o desempenho entre as diferentes regiões do Brasil e os motivadores desse desempenho</p>
              </div>

              <div className="descripition-itens">
                <h4>Deep dive regiões</h4>
                <p className="lead">Principais destaques nas regiões por segmento</p>
              </div>

            </div>
          </Accordion.Collapse>


          <Accordion.Toggle as={Button} variant="link" eventKey="1" className="btn-toggle">
            <h3>Novos consumidores</h3>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="1">
            <div className="report-itens">

              <div className="descripition-itens">
                {/* <h4>Overview do E-commerce</h4> */}
                <p className="lead">Evolução de New shoppers por segmento e quebra por mês e ano</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Categorias de produto</h4> */}
                <p className="lead">Regiões com a maior entrada de new shoppers</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>M-commerce</h4> */}
                <p className="lead">Perfil de new shoppers por segmento</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Perfil dos consumidores</h4> */}
                <p className="lead">Principais motivadores de compra de como chegou a loja para a entrada de new shoppers</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Regionalidades</h4> */}
                <p className="lead">NPS para os new shoppers, probabilidade de voltar a comprar e prazo de entrega</p>
              </div>

            </div>
          </Accordion.Collapse>

          <Accordion.Toggle as={Button} variant="link" eventKey="2" className="btn-toggle">
            <h3>Datas sazonais</h3>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="2">
            <div className="report-itens">

              <div className="descripition-itens">
                {/* <h4>Overview do E-commerce</h4> */}
                <p className="lead">Desempenho das datas sazonais 2020 vs. 2019 em faturamento, pedidos e ticket médio</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Categorias de produto</h4> */}
                <p className="lead">Evolução de New shoppers por data sazonal</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>M-commerce</h4> */}
                <p className="lead">Top categorias mais comprados por faturamento e pedidos durantes as datas</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Perfil dos consumidores</h4> */}
                <p className="lead">Desempenho de frete grátis e valor médio cobrado pelo frete por data</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Regionalidades</h4> */}
                <p className="lead">Deep dive sobre a black friday 2020</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Regionalidades</h4> */}
                <p className="lead">Datas sazonais abordadas: Sampa week, dia do consumidor, dia das mães, dia dos namorados, dia dos pais, dia das crianças, semana do Brasil, single day, black Friday, cyber Monday e o natal</p>
              </div>

            </div>
          </Accordion.Collapse>

          <Accordion.Toggle as={Button} variant="link" eventKey="3" className="btn-toggle">
            <h3>Cross border trade</h3>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="3">
            <div className="report-itens">
              <p className="lead">
                Pesquisa realizada anualmente com <b>painel de consumidores online Ebit l Nielsen (3.752 respondentes)</b> com um questionário de aproximadamente 20 perguntas, com o período de coleta de 11 á 29 de Janeiro de 2021.
              </p>

              <div className="descripition-itens">
                {/* <h4>Overview do E-commerce</h4> */}
                <p className="lead">Desempenho do Cross border trade em faturamento, pedidos e ticket médio durante ao longo dos anos</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Categorias de produto</h4> */}
                <p className="lead">Quantidade de shoppers e perfil</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>M-commerce</h4> */}
                <p className="lead">Evolução das compras em sites estrangeiros</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Perfil dos consumidores</h4> */}
                <p className="lead">Como conheceu o site estrangeiro? (Redes Sociais, Site de Busca e etc) e top sites comprados</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Regionalidades</h4> */}
                <p className="lead">Principais motivadores de compra em sites internacionais</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Regionalidades</h4> */}
                <p className="lead">Prazo médio prometido de entrega e % de frete grátis</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Regionalidades</h4> */}
                <p className="lead">Ranking de categorias mais compradas e pretensão de compra</p>
              </div>

              <div className="descripition-itens">
                {/* <h4>Regionalidades</h4> */}
                <p className="lead">Perspectiva de compras para 2021</p>
              </div>

            </div>
          </Accordion.Collapse>
        </Accordion>

        <div className="btn-purchase">
          <a href="https://pay.ebit.com.br/products/webshoppers-43-premium">Comprar</a>
        </div>

      </div>

      <section className="contato-comercial">
        <h5>
          Dúvidas? Entre em contato com nosso time comercial através do email: <a href="mailto:comercial@ebit.com.br">comercial@ebit.com.br</a>
        </h5>
      </section>

      <section className="webshoppers-43 container-fluid">
        <div className="container">
          <h2>O que é o Webshoppers</h2>
          <p className="lead">Realizado pela Ebit desde 2001, o Webshoppers é o <strong>relatório de maior credibilidade sobre o comércio eletrônico brasileiro</strong> e considerado a principal referência para os profissionais do segmento.</p>

          <p className="lead">Neste estudo, serão apresentados o cenário atual do mercado de e-commerce, as estimativas para 2020, bem como as mudanças de comportamento e preferências dos consumidores. Os insights obtidos pela pesquisa visam <strong>traçar o rumo do mercado de compras online e contribuir para o entendimento e desenvolvimento do setor.</strong></p>


          <div className="img-footer-ws-43 container">
            <img src={ImgBannerFooter} alt="Banner Medalhas" />
          </div>
        </div>
      </section>




      <div className="webshoppers-plan container">
        <h2>Confira as outras versões</h2>
        <div className="webshoppers-plan__pricing">

          <a href="https://company.ebit.com.br/webshoppers/webshoppersfree" className="webshoppers-plan__pricing__content">
            <img src={ImgWebshoppersFree} alt="" />
            <h3>Free </h3>
            <div className="value-report">
              <p><span>R$</span> 0</p>
            </div>
            <div>
              <p>
                Versão geral do relatório com as principais
                movimentações do <br /><b>E-commerce</b> em 2020
                versus 2019.
              </p>
            </div>

          </a>

          {/* <div className="webshoppers-plan__pricing__content">
            <img src={ImgWebshoppersPremium} alt="" />
            <h3>Premium </h3>
            <div className="value-report">
              <p><span>R$</span> 37.708,82</p>
            </div>
            <div>
              <ul>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Overview do <b>E-commerce</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Novos <b>Consumidores</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Datas <b>Sazonais</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Cross Border<b>Trade</b></li>
              </ul>
            </div>

          </div> */}

          <Link to="/webshoppers-capitulos" className="webshoppers-plan__pricing__content">
            <img src={ImgWebshoppersCustom} alt="" />
            <h3>Capítulos Individuais</h3>
            <div className="value-report">
              <p>Consulte</p>
            </div>
            <div>
              <ul>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Overview do <b>E-commerce</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Novos <b>Consumidores</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Datas <b>Sazonais</b></li>
                <li> <span className="fa fa-check-square-o" aria-hidden="true"></span> Cross Border<b>Trade</b></li>
              </ul>
            </div>

          </Link>

        </div>
      </div>






      <Footer />
    </>
  )
}

export default WebshoppersPremium;